<app-spinner></app-spinner>
<app-top-bar *ngIf="cargado"></app-top-bar>

<router-outlet></router-outlet>

<aside *ngIf="cargado">
  <app-legales></app-legales>
</aside>
<div id="back"></div>
<footer class="container-fluid oferta" *ngIf="cargado">
  <p>
    Copyright Banco Comafi. Todos los derechos reservados. Prohibida la
    duplicación, distribución o almacenamiento en cualquier medio.
  </p>
</footer>
